/**
 * Determine if chosen application is licensed
 * @param {Object} applications applications data
 * @param {String} applicationToCheck application to look for
 * @return {Boolean} is application licensed(true) or not(false)
 */
export const isApplicationLicensed = (applications, applicationToCheck) =>
    applications.hasOwnProperty(applicationToCheck);
